const steps = [
  {
    selector: '[projectdetail-tour="edit"]',
    content: "From here you can edit the project"
  },
  {
    selector: '[projectdetail-tour="clone-project"]',
    content: "Click here to clone or cancel the project"
  },
  {
    selector: '[projectdetail-tour="alert-task"]',
    content: "These three tiles will provide you with the most important information - current tasks, alerts and Translation Memory"
  },
  {
    selector: '[projectdetail-tour="expand-lang"]',
    content: "Now let's expand the language workspace and see the translation-related functions"
  },
  {
    selector: '[projectdetail-tour="workflow-btn"]',
    content: "You can check which workflow is being used and on which the translation currently is"
  },
  {
    selector: '[projectdetail-tour="download-btn"]',
    content: "From here you can download translations for an entire language along with bilingual review files"
  },
  {
    selector: '[projectdetail-tour="action-btn"]',
    content: "This dropdown allows to perform actions on all translations at once"
  },
  {
    selector: '[projectdetail-tour="review-btn"]',
    content: "And the most important feature click on Review to review and edit translated content right in OPAL-Marketing!"
  },
  {
    selector: '[projectdetail-tour="projectdetails-tab"]',
    content: "You can find project details and source files in the respective tabs"
  },
  {
    selector: '[projectdetail-tour="translation-tab"]',
    content: "Translation request is where you'll find information regarding the quote for the project"
  },
  {
    selector: '[projectdetail-tour="changeorder-tab"]',
    content: "Change orders allow you to add/remove source files and languages, you can find more info by navigating to the tab"
  },
  {
    selector: '[projectdetail-tour="discussion-tab"]',
    content: "From the discussions tab you can communicate with your colleagues and vendor within the project, this way we make sure that no conversation gets lost and stays associated with the project"
  },
          
];

export default steps;




